import type { Dispatch } from '../../app/redux/useAppSelector';
import {
  ACTION_PRICING_MODAL,
  CATEGORY_GROWTH,
} from '../../constants/analytics';
import type { PlanFeatureKey } from '../../organization/PricingConfig';
import PricingModal from '../../organization/PricingModal';
import { UIActions } from '../../ui/uiSlice';
import { track } from '../analytics';

export const openPricingModal = (
  dispatch: Dispatch,
  highlight?: PlanFeatureKey,
) => {
  const isOnPricingPath = window.location.pathname === pricingPath();

  const returnPath = isOnPricingPath
    ? '/'
    : window.location.pathname + window.location.search;

  if (!isOnPricingPath) {
    window.history.pushState({}, '', pricingPath(highlight));
  }

  track(ACTION_PRICING_MODAL, {
    category: CATEGORY_GROWTH,
    feature: highlight,
  });

  dispatch(
    UIActions.openModal(PricingModal, {
      highlight,
      onClose() {
        window.history.pushState({}, '', returnPath);
      },
    }),
  );
};

export default function pricingPath(highlight?: PlanFeatureKey) {
  return `/pricing${highlight ? `?${new URLSearchParams({ highlight })}` : ''}`;
}
